import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';

export async function resolveAddressCoords(raw: string): Promise<{ lat: number; lng: number } | null> {
  const config = useRuntimeConfig();
  const addressApi = useAddressApi();
  const defaultCountryCode = config.public.defaultCountryCode;

  try {
    const q = raw.replace(/\s+/g, ' ').trim();
    const request: AddressCoordinatesRequestDTO = {
      Address: q,
      CountryCode: defaultCountryCode
    };

    const proposals = await addressApi.GetCoordinates(request);
    const hit = proposals?.Data[0];

    if (hit?.Longitude == null || hit?.Latitude == null) return null;

    return { lat: hit.Latitude, lng: hit.Longitude };
  } catch {
    return null;
  }
}

export const phoneApp = {
  dialPhoneNumber(phoneNumber: string) {
    window.open('tel:' + phoneNumber);
  },

  openMap(address: string, coords?: { lat: number; lng: number } | null) {
    const sanitized = address.replace(/\s+/g, ' ').trim();
    const encoded = encodeURIComponent(sanitized);
    const platform = usePlatformStore();
    const useApple = platform.isIos && useSettingsStore()._settings.defaultMap === MapSetting.apple;

    let url: string;

    if (platform.isWeb || !coords) {
      url = useApple
        ? `http://maps.apple.com/?address=${encoded}`
        : `https://www.google.com/maps/search/?api=1&query=${encoded}`;
    } else {
      const ll = `${coords.lat},${coords.lng}`;
      url = useApple
        ? `http://maps.apple.com/?q=${encoded}&ll=${ll}`
        : `https://www.google.com/maps?q=${ll}(${encoded})`;
    }

    window.open(url, '_system');
  },

  openMail(mail: string) {
    window.open('mailto:' + mail);
  },

  openWiki() {
    window.open('https://e-komplet.dk/wiki/app-2/');
  },

  openKlarpris(projectName: string, projectReference: string) {
    const url = `https://app.klarpris.dk/?basketName=${encodeURIComponent(projectName)}&Reference=${encodeURIComponent(projectReference)}`;
    window.open(url, '_system');
  },

  openLink(link: string) {
    window.open(link);
  },

  openAppSettings() {
    NativeSettings.open({
      optionAndroid: AndroidSettings.ApplicationDetails, 
      optionIOS: IOSSettings.App
    });
  }
};
